import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { FormControl, FormLabel, RadioGroup } from "@material-ui/core";
import { Playground, Props } from "docz";
import { Space, Radio, DateRangeInput } from "../index";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "checkbox"
    }}>{`Checkbox`}</h1>
    <p>{`Base on `}<a parentName="p" {...{
        "href": "https://material-ui.com/components/checkboxes/"
      }}>{`https://material-ui.com/components/checkboxes/`}</a></p>
    <p>{`Related component`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://material-ui.com/api/form-control-label/#formcontrollabel-api"
        }}>{`https://material-ui.com/api/form-control-label/#formcontrollabel-api`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://material-ui.com/components/tooltips/"
        }}>{`https://material-ui.com/components/tooltips/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://material-ui.com/components/icons/"
        }}>{`https://material-ui.com/components/icons/`}</a></li>
    </ul>
    <p>{`Icon`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://material-ui.com/components/material-icons/"
        }}>{`https://material-ui.com/components/material-icons/`}</a></li>
    </ul>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Checkbox } from '@doopage/react-ui-kit'

const Example = () => <Checkbox />;

export default Example;
`}</code></pre>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <h3 {...{
      "id": "basic"
    }}>{`Basic`}</h3>
    <Playground __position={0} __code={'() => {\n  const [value, setValue] = React.useState(\'female\')\n  const handleChange = event => {\n    setValue(event.target.value)\n  }\n  return (\n    <FormControl component=\"fieldset\">\n      <FormLabel component=\"legend\">Gender</FormLabel>\n      <RadioGroup value={value} onChange={handleChange}>\n        <Radio value=\"female\" label=\"Female\" color=\"primary\" />\n        <Radio value=\"male\" label=\"Male\" color=\"info\" />\n        <Radio value=\"other\" label=\"Other\" disabled color=\"warning\" />\n        <Radio\n          value=\"helper\"\n          label=\"Helper text\"\n          helperText=\"this is heplerText\"\n        />\n      </RadioGroup>\n    </FormControl>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      FormControl,
      FormLabel,
      RadioGroup,
      Playground,
      Props,
      Space,
      Radio,
      DateRangeInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [value, setValue] = React.useState('female');

        const handleChange = event => {
          setValue(event.target.value);
        };

        return <FormControl component="fieldset" mdxType="FormControl">
        <FormLabel component="legend" mdxType="FormLabel">Gender</FormLabel>
        <RadioGroup value={value} onChange={handleChange} mdxType="RadioGroup">
          <Radio value="female" label="Female" color='primary' mdxType="Radio" />
          <Radio value="male" label="Male" color='info' mdxType="Radio" />
          <Radio value="other" label="Other" disabled color='warning' mdxType="Radio" />
          <Radio value="helper" label='Helper text' helperText='this is heplerText' mdxType="Radio" />
        </RadioGroup>
      </FormControl>;
      }}
    </Playground>
    <h3 {...{
      "id": "label-placement"
    }}>{`Label placement`}</h3>
    <Playground __position={1} __code={'<Space spaceWidth={15}>\n  <Radio color=\"primary\" checked labelPlacement=\"start\">\n    Primary\n  </Radio>\n  <Radio color=\"info\" checked labelPlacement=\"end\">\n    Info\n  </Radio>\n  <Radio color=\"warning\" label=\"Warning\" checked labelPlacement=\"bottom\" />\n  <Radio color=\"success\" checked labelPlacement=\"top\">\n    Success\n  </Radio>\n</Space>'} __scope={{
      props,
      DefaultLayout,
      FormControl,
      FormLabel,
      RadioGroup,
      Playground,
      Props,
      Space,
      Radio,
      DateRangeInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Space spaceWidth={15} mdxType="Space">
    <Radio color='primary' checked labelPlacement='start' mdxType="Radio">Primary</Radio>
    <Radio color='info' checked labelPlacement='end' mdxType="Radio">Info</Radio>
    <Radio color='warning' label='Warning' checked labelPlacement='bottom' mdxType="Radio" />
    <Radio color='success' checked labelPlacement='top' mdxType="Radio">Success</Radio>
  </Space>
    </Playground>
    <h3 {...{
      "id": "advanced"
    }}>{`Advanced`}</h3>
    <Playground __position={2} __code={'() => {\n  const [value, setValue] = React.useState(\'female\')\n  const handleChange = event => {\n    setValue(event.target.value)\n  }\n  return (\n    <FormControl>\n      <FormLabel>Gender</FormLabel>\n      <RadioGroup value={value} onChange={handleChange}>\n        <div style={{ display: \'flex\' }}>\n          <Radio value=\"female\">All time</Radio>\n          <Radio value=\"male\">\n            <DateRangeInput />\n          </Radio>\n        </div>\n      </RadioGroup>\n    </FormControl>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      FormControl,
      FormLabel,
      RadioGroup,
      Playground,
      Props,
      Space,
      Radio,
      DateRangeInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [value, setValue] = React.useState('female');

        const handleChange = event => {
          setValue(event.target.value);
        };

        return <FormControl mdxType="FormControl">
        <FormLabel mdxType="FormLabel">Gender</FormLabel>
        <RadioGroup value={value} onChange={handleChange} mdxType="RadioGroup">
          <div style={{
              display: 'flex'
            }}>
            <Radio value="female" mdxType="Radio">
              All time
            </Radio>
            <Radio value="male" mdxType="Radio">
              <DateRangeInput mdxType="DateRangeInput" />
            </Radio>
          </div>
        </RadioGroup>
      </FormControl>;
      }}
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Radio} table mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      